import * as React from "react"
import { connect } from "react-redux"

import {
    InlineAttachment,
    ToolboxAttachments,
} from "@tenforce/toolbox-attachments-react"

import { GlobalState } from "../../../store"
import { Labels } from "../../../util/Translations"
import { IItem } from "../../../models"

import { DispatchProps, mapDispatchToProps } from "../../cardview/actions"

import { getItemCardAttachments } from "../selectors"

export interface OwnProps {
    item: IItem
}

interface StateProps {
    attachments: ToolboxAttachments.Attachment[]
}

type Props = OwnProps & StateProps & DispatchProps

interface State {
    shouldShowAllAttachments: boolean
}

export class CardViewInlineAttachment extends React.PureComponent<
    Props,
    State
> {
    private parentAnchorHref: string

    constructor(props: Props) {
        super(props)
        this.parentAnchorHref = ""
        this.state = {
            shouldShowAllAttachments: false,
        }
    }

    render(): JSX.Element {
        const {
            item: { areAttachmentsEditable },
            attachments,
        } = this.props

        const { shouldShowAllAttachments } = this.state

        const { Attachments } = Labels
        return (
            <InlineAttachment
                cardWrapperClasses="tw-p-1 tw-w-full md:tw-w-1/2"
                uploadButtonClasses="tw-px-3"
                attachmentsPrivs={{
                    canAdd: areAttachmentsEditable,
                    canDelete: areAttachmentsEditable,
                    canEditDescription: areAttachmentsEditable,
                    canDownload: true,
                }}
                fieldName={Attachments}
                maxInitialCards={6}
                attachmentsActions={{
                    loadCounter: -1,
                    shouldShowAll: shouldShowAllAttachments,
                    onDelete: this.onDeleteAttachment,
                    onAdd: this.onAddAttachment,
                    onLoadMore: this.loadMoreAttachments,
                    onUpdateDescription: this.onUpdateAttachmentDescription,
                }}
                attachments={attachments}
                onMouseEvents={{
                    onMouseEnterBrowseDrop: this.disableParentAnchor,
                    onMouseOutBrowseDrop: this.enableParentAnchor,
                }}
                labels={{
                    openImageInNewTab: Labels.OpenImageInANewTab,
                    addDescriptionHere: Labels.AddDescriptionHere,
                    browseDropFilesHere: Labels.BrowseDropFilesHere,
                    deleteThisAttachment: Labels.Delete,
                    dropItAs: Labels.DropItAs,
                    loadNMore: Labels.LoadNMore,
                }}
            />
        )
    }

    onAddAttachment = async (request: UploadRequest): Promise<void> => {
        const {
            item: { id },
            requestAddAttachment,
        } = this.props

        const formData = new FormData()
        formData.append(request.filename, request.file)
        requestAddAttachment(id, formData)
    }

    onDeleteAttachment = async (attachmentId: number): Promise<void> => {
        const {
            item: { id },
            requestDeleteAttachment,
        } = this.props
        const { DeleteThisAttachment } = Labels
        if (confirm(DeleteThisAttachment)) {
            requestDeleteAttachment(id, attachmentId)
        }
    }

    onUpdateAttachmentDescription = async (
        objectId: number,
        value: string,
    ): Promise<void> => {
        const {
            item: { id },
            updateAttachmentDescription,
        } = this.props
        updateAttachmentDescription(id, objectId, value)
    }

    loadMoreAttachments = async (): Promise<void> => {
        this.setState({
            shouldShowAllAttachments: true,
        })
    }

    disableParentAnchor = (event: React.MouseEvent): void => {
        const target = event.target as HTMLElement
        const parentAnchor = target.closest("a") as HTMLElement
        this.parentAnchorHref = parentAnchor.getAttribute("href") as string
        parentAnchor.removeAttribute("href")
    }

    enableParentAnchor = (event: React.MouseEvent): void => {
        const target = event.target as HTMLElement
        const parentAnchor = target.closest("a") as HTMLElement
        parentAnchor.setAttribute("href", this.parentAnchorHref)
        this.parentAnchorHref = ""
    }
}

const mapStateToProps = (state: GlobalState, props: OwnProps): StateProps => ({
    attachments: getItemCardAttachments(state.cardView, props),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CardViewInlineAttachment)
